import React, { useEffect , useState } from "react";
import styled from "styled-components";
import { GetData } from "../../../SendingData";
import { Loading } from "../../Loading";
import TopLotus from "../TopLotus";
import DescField from "../../Functions/DescField";
import TourField from "../../Functions/TourField";

const BlogStyle = styled.div`
    position: relative;
    margin: 90px 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    .blog-content{
        display: flex;
        flex-direction: column;
        .blog{
            position: relative;
            display: flex;
            flex-direction: column;
            .blog-img{
                height: 30rem;
                width: 100%;
                object-fit: cover;
                margin: auto;
            }
            .overlay {
                z-index: 1;
                position: absolute;
                inset: 0 0 auto 0;
                height: 30rem;
                background-color: #00000040;
            }
            .blog-t{
                z-index: 2;
                color: var(--text-d-1);
                font-size: 3rem;
                font-weight: 600;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 12rem ;
                margin: auto;
                text-shadow: 3px 5px #000;
                .blog-date{
                    font-size: 1rem;
                    font-weight: 300;
                    margin-top: 1rem;
                }
            }
            .blog-d{
                border-radius: 4px;
                padding: 1rem 18rem;
                width: calc(100% - 36rem);
                margin-top: 1rem;
                text-align: start;
                hyphens: auto;
                -webkit-hyphens: auto;
                word-spacing: 0.05em;
                .image-box {
                    margin: 0.8rem 0;
                    width: 100%;
                    border-radius: 0.8rem;
                }
                .text-block {
                    font-family:  -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
                        "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
                        sans-serif !important;
                    font-size: 16px;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .blog-content{
            .blog{
                .blog-t{
                    font-size: 1.5rem;
                }
                .blog-d{
                    padding: 1rem 1.2rem;
                    width: calc(100% - 2.4rem);
                }
            }
        }
    }
`


const BlogPage=(props)=>{
    const [data , setData ] = useState()
    const [blogData , setBlogData ] = useState()
    const [loading , setLoading ] = useState(true)
    const [dir , setDir] = useState('ltr')

    const id = window.location.search.split('=')[1]

    useEffect(()=>{
        getBlog()
    },[localStorage.getItem('lang')])

    const getBlog=()=>{
        GetData(`https://lotusapi.farazandishan.com/api/v1/blog/bm/select?en_fa=${localStorage.getItem('lang')}&id=${id}` ,'' , processGet)
    }
    const processGet=(obj , data)=>{
        let response = JSON.parse(data)
        setData(response['0'])
        setBlogData(response.data)
        setLoading(false)
        if(localStorage.getItem('lang') === 'en'){
            setDir('ltr')
        }else{
            setDir('rtl')
        }
    }
    if(loading){
       return <Loading/>
    }
    const blogPart=()=>{
        if(data){
            let parts = data.map((v , index)=>{
                if(v.BDType_id === 5){
                    return <img className="image-box" src={v.BD_Data}/>
                }
                let textFields = JSON.parse(v.BD_Data);

                // if === 10 // tour package
                if(v.BDType_id === 10){
                    return (
                        <TourField textFields={textFields}/>
                    )
                }
                return(
                    <DescField textFields={textFields}/>
                )
            });
            return (
                <div className={"blog "}>
                    <div className='blog-t'>
                        {blogData[0].BM_Title}
                        {/* <span className="blog-date">{date}</span> */}
                    </div>
                    <img src={blogData[0].BM_Image} className="blog-img"/>
                    <div className="overlay"></div>
                    <div className="blog-d">
                        {parts}
                    </div>
                </div>
            )
        }else{
            return <Loading/>
        }
    }
    return(
        <BlogStyle>
            {/* <TopLotus/> */}
            <div className="blog-content" style={{direction: dir}}>
                {blogPart()}
            </div>
        </BlogStyle>
    )
}
export default BlogPage;